import React, { forwardRef, useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { createOrderInvoice, fetchCompaniesInfo, fetchInvoiceParams, getLogo, uploadLogo } from '../../../Reducers/balance'
import { Button, DatePicker, Form, Input, Select, Spin, Typography, Upload, message } from 'antd'
import './styles.scss';
import FormItem from './FormItem';
import { EditOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import CreateCompanyDrawer from './CreateCompanyDrawer';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { useNavigate } from 'react-router-dom';

dayjs.extend(utc);

const { Option } = Select;
const { Title, Text } = Typography;

const FillShippingForm = forwardRef(({ selectedIds, close, setNewInvoiceId }, ref) => {

  // GET /api/v2/mgr/invoices/mycompanies -> get list of companies
  // POST /api/v2/mgr/invoices/mycompanies -> add/edit company
  // POST /invoices/fromorders -> create invoice
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [company, setCompany] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [imageLaoding, setImageLoading] = useState(false);
  const [colorToSend, setColorToSend] = useState(0);

  // Get companies info
  // const { payload, isLoading } = useSelector((state) => state.balance.getCompanies, shallowEqual)

  useEffect(() => {
    dispatch(fetchCompaniesInfo());
    dispatch(fetchInvoiceParams())
  }, []);

  const { payload, isLoading } = useSelector(state => 
    state.balance.getCompanies, shallowEqual
  );

  const dataTo = useSelector(state => 
    state.balance.getParams, shallowEqual
  );
  
  const payloadTo = dataTo?.payload?.invoiceTo

    // Fill the form with necessary data
    const handleSelectChange = (id) => {
      setCompany(id)
      const selectedOption = payload.find((option) => option.id === id);

    if (selectedOption) {
      form.setFieldsValue({
        ...form.getFieldsValue(),
        ...selectedOption.invoiceParams, 
      });

      setColorToSend(selectedOption.invoiceParams.backgroundColor)

    }
    };

    const handleFillInvoiceTo = (id) => {
      const selectedOption = payloadTo.find((option) => option.id === id);

    if (selectedOption) {
      form.setFieldsValue({
        ...form.getFieldsValue(),
        ...selectedOption,
      });
    }
    };

  // Create invoice
  const handleCreateInvoice = (formData) => {

    const docDate = +(dayjs(formData.docDate).valueOf())

    const dataWithTaxAndTemplate = { ...formData, docDate, companyId: company, backgroundColor: colorToSend, tax: 0.1 }

    const data = {
        orders: selectedIds,
        data: dataWithTaxAndTemplate
    }

    dispatch(createOrderInvoice(data))
    .then((res) => {
      message.success(`Successfully created invoice!`);
      const invoiceId = res.invoiceId;
      navigate(`/balance?type=list_invoices&highlight=${invoiceId}`);
      close();
    })
    .catch((err) => {
      message.error(`Failed to create invoice: ${err}`)
    })
  }

  const beforeUpload = (file) => {
    const reader = new FileReader();
    setImageLoading(true);
    reader.readAsArrayBuffer(file);
    reader.onloadend = () => {
        const byteArray = new Uint8Array(reader.result);
        const data = {id: company, payload: byteArray}

        dispatch(uploadLogo(data))
        .then((res) => {
          message.success("Logo uploaded!")
        })
        .catch((err) => {
          message.error(`Failed to upload logo! ${err}`)
        })
        .finally(() => {
          setImageLoading(false)
        })
    };

    setFileList([file]);
    
    return false;
};

const uploadFun = useSelector(state => state.balance.uploadLogo, shallowEqual);

const loadingLogo = uploadFun?.isLoading

useEffect(() => {
  form.setFieldsValue({
    docDate: dayjs.utc().startOf("day"),
  });
}, [form]);


  return (
    isLoading ? <Spin /> : <Form
      ref={ref}
      form={form}
      onFinish={handleCreateInvoice}
      className="shipping_form"

    >
      <div className="shipping_form__inputs">
        <Title className="shipping_form__title" level={5}>Invoice to</Title>
        <Select onChange={handleFillInvoiceTo} placeholder="Select a company">
          {payloadTo?.map((option) => (
            <Option key={option.id} value={option.id}> 
              {option.toName}
            </Option>
          ))}
        </Select>
      <FormItem title={"Company name"} attribute={"toName"} placeholder={"Company name"} />
      <FormItem title={"Address line 1"} attribute={"toLine1"} placeholder={"Address line 1"} />
      <FormItem title={"Address line 2"} attribute={"toLine2"} placeholder={"Address line 2"}  />
      <FormItem title={"Address line 3"} attribute={"toLine3"} placeholder={"Address line 3"}  />
      </div>

      <div className="shipping_form__inputs">
      <Title className="shipping_form__title" level={5}>Invoice from {imageLaoding ? <Spin /> 
      : company && 
        <img src={`https://wholesale.quantummosaic.net/cargo/api/v2/mgr/invoices/mycompanies/${company}/logo`} alt="Logo" style={{ maxWidth: 20 }} />}</Title>
      <Select onChange={handleSelectChange} placeholder="Select a company">
          {payload?.map((option) => (
            <Option key={option.id} value={option.id}>
              {option.name}
            </Option>
          ))}
        </Select>

    
      <CreateCompanyDrawer companyId={company} companyPayload={payload} setCompany={setCompany} />
      <Upload
                    disabled={company == null}
                    fileList={fileList}
                    beforeUpload={beforeUpload}
                    showUploadList={{ showRemoveIcon: false }} // Prevent removal (handled in Redux)
                >
                    <Button icon={<UploadOutlined />} loading={loadingLogo}>
                        {loadingLogo ? "Uploading..." : "Click to Upload logo"}
                    </Button>
                </Upload>
                
      <div style={{display: 'none'}}>
        <FormItem title={"Id"} attribute={"template"} placeholder={"Company name"} />
      </div>
      <FormItem title={"Company name"} attribute={"fromName"} placeholder={"Company name"}  />
      <FormItem title={"Address line 1"} attribute={"fromLine1"} placeholder={"Address line 1"} />
      <FormItem title={"Address line 2"} attribute={"fromLine2"} placeholder={"Address line 2"} />
      <FormItem title={"Address line 3"} attribute={"fromLine3"} placeholder={"Address line 3"} />
      </div>

      <div className="shipping_form__inputs short">
      <Title className="shipping_form__title" level={5}>Invoice cap</Title>
      <FormItem title={"Invoice number"} attribute={"docNumber"} placeholder={"Invoice number"} />
      {/* <FormItem title={"Invoice date"} attribute={"docDate"} placeholder={"Invoice date"} /> */}
      <Text strong>Invoice date</Text>
      <Form.Item
        name={"docDate"}
        getValueProps={(value) => ({
          value: value ? dayjs.utc(value) : null,
        })}
        normalize={(value) => (value ? dayjs.utc(value) : null)}
      >
      <DatePicker
                showTime={false}
                size="large"
                style={{ width: '100%' }}
                // DEFAULT_FORMAT
              />
      </Form.Item>
      </div>

      <div className="shipping_form__inputs">
      <Title className="shipping_form__title" level={5}>Pay to</Title>

      <FormItem title={"Account holder"} attribute={"accountHolder"} placeholder={"Account holder"} />
      <FormItem title={"SWIFT"} attribute={"swift"} placeholder={"SWIFT"} />
      <FormItem title={"Address"} attribute={"address"} placeholder={"Address"} />
      <FormItem title={"IBAN"} attribute={"iban"} placeholder={"IBAN"} />
      <FormItem title={"Bank"} attribute={"bank"} placeholder={"Bank"} />
      <FormItem title={"Comment"} attribute={"comment1"} placeholder={"Comment"} />
      </div>
    </Form>
  )
})

export default FillShippingForm
